import { FC, PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';

import { CardActionArea } from '@mui/material';

interface CardActionProps {
  launchUrl: string;
  target: boolean;
  onCreateReport: () => void;
}

const CardAction: FC<PropsWithChildren<CardActionProps>> = ({
  children,
  launchUrl,
  target,
  onCreateReport,
}) => (
  <Link to={launchUrl} target={target ? '_blank' : '_self'}>
    <CardActionArea
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
      }}
      onClick={() => onCreateReport()}
    >
      {children}
    </CardActionArea>
  </Link>
);

export default CardAction;
